
import { Vue, Component } from "vue-property-decorator";
// import Carousel from '@/components/carousel/index.vue';
import Contactus from '@/components/contact-us/index.vue';
import Products from '@/components/products/index.vue';
import Freeproducts from '@/components/freeproducts/index.vue';
import RequestButton from '@/components/request-button/parts/request-button.vue';

import user_module from '@/modules/user/index';

@Component({
  components:{
    Products,
    Contactus,
    Freeproducts,
    RequestButton
  }
})

export default class PageHome extends Vue {


  get token(){

    return user_module.token;

  }




  down(){

    const scrollSection: any = this.$refs.products

    if (scrollSection){

      const freeproducts = scrollSection.$el.querySelector('#free-products');
      const top = freeproducts.getBoundingClientRect().top;
      console.log('top', top)
      window.scrollTo({
        top: top - 60,
        behavior: 'smooth'
      });
    }

  }

}
